import { render, staticRenderFns } from "./ConnectControls.vue?vue&type=template&id=60a4905c&scoped=true&"
import script from "./ConnectControls.vue?vue&type=script&lang=js&"
export * from "./ConnectControls.vue?vue&type=script&lang=js&"
import style0 from "./ConnectControls.vue?vue&type=style&index=0&id=60a4905c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4905c",
  null
  
)

export default component.exports